import { Box, Chip } from '@frontierag/frontier-ui-library';
import { styles } from './styles';
import type { ICropSelectOption } from './types';
import { v4 as uuidv4 } from 'uuid';

export default function CropSelectOption({
  props,
  itemDescription,
  itemReference,
}: ICropSelectOption) {
  return (
    <li {...props} key={uuidv4()}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        width={1}
        data-testid="crop-select-option"
      >
        <Box>{itemDescription}</Box>
        <Chip size="small" label={itemReference} sx={styles.chip} color="primary" />
      </Box>
    </li>
  );
}
